import type { Locale } from '@application/Types/Locale'
import { Direction } from '@mui/material/styles'
export const languages: { locale: Locale; name: string }[] = [
    {
        locale: 'en',
        name: 'English',
    },
    { locale: 'es', name: 'Español' },
    { locale: 'de', name: 'Deutsch' },
    { locale: 'nl', name: 'Nederlands' },
    { locale: 'ar', name: 'عربى' },
]

export const MAP_LOCALE_DIRECTION: Record<Locale, Direction> = {
    en: 'ltr',
    es: 'ltr',
    de: 'ltr',
    nl: 'ltr',
    ar: 'rtl',
}
